import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoute = () => {
  const auth = localStorage.getItem("token");
  const location = useLocation();
  return auth ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute;
